module.exports = __webpack_public_path__ + "static/media/JS.3d3ed003.png";